import { gql } from '@apollo/client';

export const GET_ALL_PRODUCT_CATEGORIES = gql(/* GraphQL */ `
    query GetAllProductCategories {
        getAllProductCategories {
            id
            name
        }
    }
`);
